// import React from 'react'
// import { MuiTextfield } from 'material-ui-elements'
import _ from 'lodash'
import core from '../../core'
import common from '../../common'

const {
  helpers: {
    calculateAge,
    getLoginFromMail,
    getUserId,
    isPhone,
    isEmail,
    isFax,
    keepInLength,
    validateLength,
    calculatePeriod
  }
} = core

const {
  constants: { nationalities, gender }
} = common

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const idColumns = [
  { columnName: 'placement.careStatus', tableName: 'careStatus' },
  { columnName: 'social.workRegion', tableName: 'workRegion' },
  { columnName: 'social.workArea', tableName: 'workArea' },
  { columnName: 'social.workTeam', tableName: 'workTeam' },

  {
    columnName: 'placement.admission.serviceTypeFrom',
    tableName: 'serviceType'
  },
  {
    columnName: 'placement.admission.placementTypeFrom',
    tableName: 'placementType'
  },
  { columnName: 'placement.discharge.type', tableName: 'dischargeType' },
  {
    columnName: 'placement.discharge.placementTypeTo',
    tableName: 'placementType'
  },
  { columnName: 'placement.discharge.serviceTypeTo', tableName: 'serviceType' }
]

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'person.fullName',
      'person.nationality',
      'person.dob',
      'person.age',
      'person.gender',
      'placement.careStatus',
      'social.workRegion',
      'social.workArea',
      'placement.placementStatus.id',
      'placement.admission.admissionDate',
      'placement.admission.centreNameTo.name',
      'placement.discharge.placementDuration'
    ]
  }
]

export const defaultSorting = [
  { columnName: 'person.gender', direction: 'asc' }
]

export const placementStatus = [
  { id: 10, label: 'In Placement' },
  { id: 20, label: 'Discharged from Centre' },
  { id: 30, label: 'Discharged from Service ' }
]

export const careStatus = [
  { id: 1, label: 'Emergency Care Order' },
  { id: 2, label: 'Full Care Order' },
  { id: 3, label: 'Interim Care Order' },
  { id: 4, label: 'Interim Special Care Order' },
  { id: 5, label: 'No Care Order' },
  { id: 6, label: 'Section 12' },
  { id: 7, label: 'Section 5' },
  { id: 8, label: 'Special Care Order' },
  { id: 9, label: 'Supervision Order' },
  { id: 10, label: 'Voluntary Care' },
  { id: 11, label: 'Data Pending' }
]

export const workRegion = [
  { id: 1, label: 'DML' },
  { id: 2, label: 'DNE' },
  { id: 3, label: 'OOS' },
  { id: 4, label: 'SOUTH' },
  { id: 5, label: 'WEST' },
  { id: 6, label: 'Data Pending' },
  { id: 7, label: 'N / A' }
]

export const workArea = [
  { id: 1, label: 'C' },
  { id: 2, label: 'S/L/WC' },
  { id: 3, label: 'C/K/ST' },
  { id: 4, label: 'C/M' },
  { id: 5, label: 'D' },
  { id: 6, label: 'DNC' },
  { id: 7, label: 'DN' },
  { id: 8, label: 'DSC' },
  { id: 9, label: 'DSE/W' },
  { id: 10, label: 'DSW/K/WW' },
  { id: 11, label: 'G/R' },
  { id: 12, label: 'K' },
  { id: 13, label: 'W/W' },
  { id: 14, label: 'L/M' },
  { id: 15, label: 'M' },
  { id: 16, label: 'M/W' },
  { id: 17, label: 'MID' },
  { id: 18, label: 'OOS' },
  { id: 19, label: 'Data Pending' }
]

export const workTeam = [
  { id: 1, label: 'Child Protection' },
  { id: 2, label: 'Children in Care' },
  { id: 3, label: ' Duty / Intake' },
  { id: 4, label: 'Long-Term' },
  { id: 5, label: 'Welfare' },
  { id: 6, label: 'Children in Community' },
  { id: 7, label: 'Data Pending' }
]

export const placementType = [
  { id: 1, label: 'Aftercare' },
  { id: 2, label: 'CRS' },
  { id: 3, label: 'Detention' },
  { id: 4, label: 'Disability' },
  { id: 5, label: 'Family' },
  { id: 6, label: 'Family Friend' },
  { id: 7, label: 'Foster Care' },
  { id: 8, label: 'Home' },
  { id: 9, label: 'Homeless' },
  { id: 10, label: 'Hospital' },
  { id: 11, label: 'Hostel' },
  { id: 12, label: 'Independent Living' },
  { id: 13, label: 'Medical / Mental Health' },
  { id: 14, label: 'No Placement (Deceased)' },
  { id: 15, label: 'No Placement (Homeless)' },
  { id: 16, label: 'No Placement (Missing)' },
  { id: 17, label: 'Respite' },
  { id: 18, label: 'Supported Lodgings' },
  { id: 19, label: 'Data Pending' },
  { id: 20, label: 'N / A' }
]

export const serviceType = [
  { id: 1, label: 'Aftercare Service' },
  { id: 2, label: 'CRS - Aftercare Preparation' },
  { id: 3, label: 'CRS - Assessment' },
  { id: 4, label: 'CRS - Block Book' },
  { id: 5, label: 'CRS - Emergency' },
  { id: 6, label: 'CRS - General' },
  { id: 7, label: 'CRS - General w/ Emergency Capacity' },
  { id: 8, label: 'CRS - High Support' },
  { id: 9, label: 'CRS - Mother and Baby' },
  { id: 10, label: 'CRS - Out of State' },
  { id: 11, label: 'CRS - Pedagogy ' },
  { id: 12, label: 'CRS - Respite' },
  { id: 13, label: 'CRS - SCSA' },
  { id: 14, label: 'CRS - Special Arrangement' },
  { id: 15, label: 'CRS - Special Care' },
  { id: 16, label: 'CRS - Specialist / Clinical ' },
  { id: 17, label: 'CRS - Spot Purchase' },
  { id: 18, label: 'CRS - Spot Purchase Emergency' },
  { id: 19, label: 'Detention School ' },
  { id: 20, label: 'Direct Provision' },
  { id: 21, label: 'Disability Service' },
  { id: 22, label: 'Homeless Service' },
  { id: 23, label: 'Hospital / Clinic - Medical' },
  { id: 24, label: 'Hosptial / Clinic - Mental Health' },
  { id: 25, label: 'Hospital / Clinic - Other' },
  { id: 26, label: 'Prison' },
  { id: 27, label: 'Respite Service' },
  { id: 28, label: 'Supported Lodgings' },
  { id: 29, label: 'Data Pending' },
  { id: 30, label: 'N / A' }
]

export const placementPurpose = [
  {
    id: 1,
    label:
      'To care for this young person pending placement in a High Support Unit'
  },
  {
    id: 2,
    label:
      'To care for this young person pending placement in Out of State Care'
  },
  {
    id: 3,
    label: 'To care for this young person pending placement in Special Care'
  },
  {
    id: 4,
    label:
      'To help prepare this young person for Independent / Supported Living'
  },
  {
    id: 5,
    label:
      'To help prepare this young person to live in Stat/Vol Residential Services'
  },
  { id: 6, label: 'To help prepare this young person to live with Relatives' },
  { id: 7, label: 'To help prepare this young person to move to Foster Care' },
  { id: 8, label: 'To help prepare this young person to Return Home' },
  {
    id: 9,
    label: 'To help prepare this young person to return to Foster Care'
  },
  {
    id: 10,
    label: 'To help prepare this young person to return to independent living'
  },
  {
    id: 11,
    label: 'To help prepare this young person to return to live with relatives'
  },
  {
    id: 12,
    label:
      'To help prepare this young person to return to Stat/Vol Residential Services'
  },
  {
    id: 13,
    label:
      "To help SW determine this young person's med-long term placement needs"
  },
  {
    id: 14,
    label: "To help SW determine this young person's short-term placement needs"
  },
  {
    id: 15,
    label:
      'To provide Respite Care to help this young person maintain his/her existing placement'
  },
  {
    id: 16,
    label: 'To provide this young person a Holding / Bridging placement'
  },
  {
    id: 17,
    label: 'To provide this young person a short-term Aftecare service'
  },
  { id: 18, label: 'To provide this young person long-term Specialist Care ' },
  {
    id: 19,
    label: 'To provide this young person short-medium term Specialist Care '
  },
  { id: 20, label: 'Data Pending' },
  { id: 21, label: 'N / A ' }
]

export const dischargeType = [
  { id: 1, label: 'Planned - In Care Plan - Negative Placement Outcome' },
  { id: 2, label: 'Planned - In Care Plan - Positive Placement Outcome' },
  { id: 3, label: 'Planned - In Care Plan - Mixed Placement Outcome' },
  {
    id: 4,
    label:
      'Unplanned - Not in Care Plan - >2wks Notice Given - Negative Placement Outcome'
  },
  {
    id: 5,
    label:
      'Unplanned - Not in Care Plan - >2wks Notice Given - Positive Placement Outcome'
  },
  {
    id: 6,
    label:
      'Unplanned - Not in Care Plan - >2wks Notice Given - Mixed Placement Outcome'
  },
  {
    id: 7,
    label:
      'Emergency Discharge - Not in Care Plan - <2wks Notice Given - Negative Placement Outcome'
  },
  {
    id: 8,
    label:
      'Emergency Discharge - Not in Care Plan - <2wks Notice Given - Positive Placement Outcome'
  },
  {
    id: 9,
    label:
      'Emergency Discharge - Not in Care Plan - <2wks Notice Given - Mixed Placement Outcome'
  },
  {
    id: 10,
    label:
      'Discharge from Assessment, Emergency, Short-Term, Respite or Aftercare Placement'
  },
  { id: 11, label: 'Data Pending' }
]

export const senStatus = [
  { id: 1, label: 'Complaint - Review Ongoing' },
  { id: 2, label: 'CPC / D - Review Ongoing' },
  { id: 3, label: 'MCFC - Episode Ongoing' },
  { id: 4, label: 'Restrictive Practice - Use Ongoing' },
  { id: 5, label: 'SEN - Clarification / Revision Pending' },
  { id: 6, label: 'Closed' }
]

export const valueTable = {
  placementStatus,
  careStatus,
  workRegion,
  workArea,
  workTeam,
  serviceType,
  placementType,
  placementPurpose,
  dischargeType,
  nationalities,
  gender,
  senStatus
}

export const columns = [
  {
    name: 'id',
    title: 'ID',
    formField: true
  },
  {
    name: 'person.id',
    title: 'YP UI',
    // width: 70,
    // maxChars: 6,
    minSpace: 'YP UIw ',
    formField: true
  },
  {
    name: 'person.firstName',
    title: "Young Person's First Name(s)",
    formField: true,
    maxChars: 50,
    minSpace: "Young Person's ",
    filterField: true
  },
  {
    name: 'person.lastName',
    title: "Young Person's Surname",
    formField: true,
    maxChars: 50,
    minSpace: "Young Person's ",
    filterField: true
  },
  {
    name: 'person.fullName',
    title: "Young Person's Name",
    formField: true,
    maxChars: 100,
    minSpace: "Young Person's "
  },
  {
    name: 'person.initials',
    title: "Young Person's Initials",
    // width: 100,
    formField: true,
    maxChars: 10,
    minSpace: "Young Person's ",
    filterField: true
  },
  {
    name: 'person.nationality',
    title: "Young Person's Nationality",
    formField: true,
    type: 'select',
    options: 'nationalities',
    filterField: true,
    minSpace: "Young Person's "
  },
  {
    name: 'person.dob',
    title: "Young Person's Date of Birth",
    // width: 130,
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: "Young Person's "
  },
  {
    name: 'person.age',
    title: 'Current Age',
    formField: true,
    getCellValue: row => calculateAge(row[`person.dob`]),
    minSpace: 'Current A ',
    filterField: true,
    filterTitle: "Young Person's Age"
  },
  {
    name: 'person.gender',
    title: 'Gender',
    // width: 80,
    formField: true,
    type: 'select',
    options: 'gender',
    filterField: true,
    minSpace: 'Gender '
  },
  {
    name: 'placement.careStatus',
    title: "Young Person's Care Status",
    formField: true,
    type: 'select',
    options: 'careStatus',
    filterField: true,
    minSpace: "Young Person's "
  },
  {
    name: 'placement.primaryReason.label',
    title: 'Primary Reason Young Person in Care',
    formField: true,
    type: 'select',
    options: 'reasons',
    filterField: true,
    filterTitle: 'Primary Reason in Care',
    minSpace: 'Young Person Young '
  },
  {
    name: 'placement.placementNumber',
    title: 'No. of Previous Placements',
    formField: true,
    // maxChars: 3,
    filterField: true,
    minSpace: 'No. of Previous '
  },
  {
    name: 'person.parents.motherName',
    title: "Mother's Name",
    formField: true,
    maxChars: 50
  },
  {
    name: 'person.parents.motherAddress',
    title: "Mother's Address",
    formField: true,
    maxChars: 300
  },
  {
    name: 'person.parents.fatherName',
    title: "Father's Name",
    formField: true,
    maxChars: 50
  },
  {
    name: 'person.parents.fatherAddress',
    title: "Father's Address",
    formField: true,
    maxChars: 300
  },
  {
    name: 'social.workRegion',
    title: 'Social Work Region',
    formField: true,
    type: 'select',
    options: 'workRegion',
    getCellValue: row =>
      _.get(
        valueTable.workRegion,
        `[${_.findIndex(valueTable.workRegion, [
          'id',
          row[`social.workRegion`]
        ])}].label`,
        row[`social.workRegion`]
      ),
    filterField: true,
    minSpace: 'Social Work '
  },
  {
    name: 'social.workArea',
    title: 'Social Work Area',
    formField: true,
    type: 'select',
    options: 'workArea',
    getCellValue: row =>
      _.get(
        valueTable.workArea,
        `[${_.findIndex(valueTable.workArea, [
          'id',
          row[`social.workArea`]
        ])}].label`,
        row[`social.workArea`]
      ),
    filterField: true,
    minSpace: 'Social Work '
  },
  {
    name: 'social.workTeam',
    title: 'Social Work Team',
    formField: true,
    type: 'select',
    options: 'workTeam',
    getCellValue: row =>
      _.get(
        valueTable.workTeam,
        `[${_.findIndex(valueTable.workTeam, [
          'id',
          row[`social.workTeam`]
        ])}].label`,
        row[`social.workTeam`]
      ),
    filterField: true,
    minSpace: 'Social Work '
  },
  {
    name: 'social.workerName',
    title: 'Social Worker Name',
    formField: true,
    maxChars: 50,
    minSpace: 'Social Worker ',
    filterField: true
  },
  {
    name: 'social.workerAddress',
    title: 'Social Worker Address',
    formField: true,
    maxChars: 300,
    minSpace: 'Social Worker '
  },
  {
    name: 'social.workerPhones[0].phone',
    title: 'Social Worker Phone No.',
    formField: true,
    maxChars: 10,
    minSpace: 'Social Worker '
  },
  {
    name: 'social.workerFax',
    title: 'Social Worker Fax No.',
    formField: true,
    maxChars: 10,
    filterField: true,
    minSpace: 'Social Worker  '
  },
  {
    name: 'social.workerEmails[0].email',
    title: 'Social Worker Email Address',
    formField: true,
    minSpace: 'Email Address '
  },
  {
    name: 'social.validFrom',
    title: 'Social Worker Details Valid at Date',
    formField: true,
    type: 'date',
    minSpace: 'Details Valid at Date '
  },
  {
    name: 'placement.placementStatus.id',
    title: 'Placement Status',
    formField: true,
    // width: 200,
    type: 'select',
    options: 'placementStatus',
    getCellValue: row =>
      _.get(
        valueTable.placementStatus,
        `[${_.findIndex(valueTable.placementStatus, [
          'id',
          row[`placement.placementStatus.id`]
        ])}].label`,
        row[`placement.placementStatus.id`]
      ),
    filterField: true
  },
  {
    name: 'placement.placementStatus.validFrom',
    title: 'Placement Status Valid at Date',
    formField: true,
    type: 'date', //daterange ?
    filterField: true,
    minSpace: 'Placement Status '
  },
  {
    name: 'placement.placementPurpose.id',
    title: 'Placement Purpose',
    formField: true,
    type: 'select',
    options: 'placementPurpose',
    getCellValue: row =>
      _.get(
        valueTable.placementPurpose,
        `[${_.findIndex(valueTable.placementPurpose, [
          'id',
          row[`placement.placementPurpose.id`]
        ])}].label`,
        row[`placement.placementPurpose.id`]
      ),
    filterField: true
  },
  {
    name: 'placement.placementPurpose.validFrom',
    title: 'Placement Purpose Valid at Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Placement Purpose '
  },
  {
    name: 'placement.admission.admissionDate',
    title: 'Date of Admission',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Admission '
  },
  {
    name: 'placement.admission.admissionAge',
    title: 'Age at Admission',
    formField: true,
    getCellValue: row =>
      calculatePeriod(
        row[`placement.admission.admissionDate`],
        row[`person.dob`]
      ),
    filterField: true,
    // maxChars: 3
    minSpace: 'Admission '
  },
  {
    name: 'placement.admission.placementTypeFrom',
    title: 'Admitted from Placement Type',
    formField: true,
    type: 'select',
    options: 'placementType',
    filterField: true,
    minSpace: 'Placement Type '
  },
  {
    name: 'placement.admission.serviceTypeFrom',
    title: 'Admitted From Service Type',
    formField: true,
    type: 'select',
    options: 'serviceType',
    filterField: true,
    minSpace: 'Admitted From '
  },
  {
    name: 'placement.admission.centreNameTo.name',
    title: 'Admitted to Centre Name',
    formField: true,
    type: 'select',
    options: 'centres',
    filterField: true,
    minSpace: 'Centre Name '
  },
  // {
  //   name: 'admission.centreAddress',
  //   title: 'Centre Address',
  //   formField: true
  // },
  {
    name: 'placement.discharge.dischargeDate',
    title: 'Date of Discharge',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Discharge '
  },
  {
    name: 'placement.discharge.dischargeAge',
    title: 'Age at Discharge',
    formField: true,
    getCellValue: row =>
      calculatePeriod(
        row[`placement.discharge.dischargeDate`],
        row[`person.dob`]
      ),
    filterField: true,
    // maxChars: 3
    minSpace: 'Discharge '
  },
  {
    name: 'placement.discharge.placementDuration',
    title: 'Duration of Placement',
    formField: true,
    getCellValue: row =>
      calculatePeriod(
        row[`placement.discharge.dischargeDate`],
        row[`placement.admission.admissionDate`]
      ),
    filterField: true,
    minSpace: 'Duration of  '
  },
  {
    name: 'placement.discharge.placementTypeTo',
    title: 'Discharged To Placement Type',
    formField: true,
    type: 'select',
    options: 'placementType',
    filterField: true,
    minSpace: 'Placement Type '
  },
  {
    name: 'placement.discharge.serviceTypeTo',
    title: 'Discharged to Service Type',
    formField: true,
    type: 'select',
    options: 'serviceType',
    filterField: true,
    minSpace: 'Discharged To '
  },
  {
    name: 'placement.discharge.organizationTo',
    title: 'Discharge to Organisation',
    formField: true,
    maxChars: 50,
    filterField: true,
    minSpace: 'Organization '
  },
  {
    name: 'placement.discharge.type',
    title: 'Discharge Type',
    formField: true,
    type: 'select',
    options: 'dischargeType',
    filterField: true,
    minSpace: 'Discharge '
  },
  {
    name: 'notes.placement',
    title: 'Placement Notes ',
    formField: true,
    maxChars: 500,
    filterField: true,
    minSpace: 'Placement '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues,
  activeFormName
}) => {
  const forms = [
    {
      id: 1,
      name: 'ypd',
      disabled: activeFormName !== 'ypd',
      activeName: 'person',
      historyName: 'personHistory',
      label: 'Young Person Details',
      icon: 'person',
      // hidden: true,
      // disabled: true,
      fields: [
        {
          type: fields.select,
          style: { width: 500 }, // { ...styles.fieldText, width: 500 },
          disabled: !add,
          // hidden: addPerson, //disabled,
          // floatingLabelStyle: { ...styles.floatingLabel },
          name: 'person.id',
          label: 'Young Person',
          // hint: 'Select Person',
          required: showAsterix,
          onChange: (e, v) => proceedSelectionChange(formName, v),
          validate: v => (v ? undefined : 'Field is required'),
          options: persons.filter(f => f.id > 0 || f.id === 'new').map(o => {
            return {
              value: o.id,
              label:
                o.id === 'new'
                  ? o.label
                  : `${o.lastName} ${o.firstName} (${o.initials})`
            }
          })
        },
        [
          {
            type: fields.text,
            // style: { ...styles.fieldText },
            floatingLabelStyle: { width: 100 }, // { ...styles.floatingLabel, width: 100 },
            name: 'person.ui',
            label: 'NCCIS No.',
            maxChars: 10,
            // hint: 'Enter Name',
            required: showAsterix,
            disabled: !personAdd && (disabled || activeFormName !== 'ypd'),
            normalize: v => {
              const val = keepInLength(v, 10)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.text,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'person.firstName',
            label: 'First Name',
            maxChars: 50,
            // hint: 'Enter Name',
            required: showAsterix,
            disabled: !personAdd && (disabled || activeFormName !== 'ypd'),
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            onChange: (e, v) =>
              change(
                formName,
                'person.fullName',
                `${formValues.person.firstName || ''} ${formValues.person
                  .lastName || ''}`
              ),
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.text,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'person.lastName',
            label: 'Surname', //'Last Name',
            maxChars: 50,
            // hint: 'Enter Surname',
            required: showAsterix,
            disabled: !personAdd && (disabled || activeFormName !== 'ypd'),
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            onChange: (e, v) =>
              change(
                formName,
                'person.fullName',
                `${formValues.person.firstName || ''} ${formValues.person
                  .lastName || ''}`
              ),
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.text,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'person.fullName',
            label: 'Name',
            hidden: true,
            // hint: '',
            // maxChars: 100,
            required: false,
            disabled: true
          },
          {
            type: fields.text,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'person.initials',
            label: 'Initials', //"Young Person's Initials",
            maxChars: 10,
            // hint: 'Enter Initials',
            required: showAsterix,
            disabled: !personAdd && (disabled || activeFormName !== 'ypd'),
            normalize: v => {
              const val = keepInLength(v, 10)
              return val.toUpperCase()
            },
            validate: v =>
              v
                ? validateLength(v, 10)
                  ? undefined
                  : 'Filed is limited to 10 chars'
                : 'Field is required'
          }
        ],
        [
          {
            type: fields.select,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'person.nationality',
            label: 'Nationality',
            maxChars: 32,
            // hint: 'Select Nationality',
            required: showAsterix,
            disabled: !personAdd && (disabled || activeFormName !== 'ypd'),
            validate: v => (v ? undefined : 'Field is required'),
            options: valueTable.nationalities.filter(f => f.id > 0).map(o => {
              return { value: o.label, label: o.label }
            })
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'person.dob',
            label: 'Date of Birth', //"Young Person's Date of Birth",
            maxChars: 20,
            required: showAsterix,
            disabled: !personAdd && (disabled || activeFormName !== 'ypd'),
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            onChange: (e, v) => {
              change(formName, 'person.age', calculateAge(v))
              change(
                formName,
                'placement.discharge.dischargeAge',
                calculatePeriod(
                  v,
                  formValues &&
                    formValues.placement &&
                    formValues.placement.discharge &&
                    formValues.placement.discharge.dischargeDate
                )
              )
              change(
                formName,
                'placement.admission.admissionAge',
                calculatePeriod(
                  v,
                  formValues &&
                    formValues.placement &&
                    formValues.placement.admission &&
                    formValues.placement.admission.admissionDate
                )
              )
              change(
                formName,
                'placement.discharge.placementDuration',
                calculatePeriod(
                  formValues &&
                    formValues.placement &&
                    formValues.placement.discharge &&
                    formValues.placement.discharge.dischargeDate,
                  formValues &&
                    formValues.placement &&
                    formValues.placement.admission &&
                    formValues.placement.admission.admissionDate
                )
              )
            },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.text,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'person.age',
            label: 'Age', //"Young Person's Current Age",
            maxChars: 12,
            // hint: '',
            // normalize: v=> ddy(v),
            disabled: true
          },
          {
            type: fields.select,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'person.gender',
            label: 'Gender', //"Young Person's Gender",
            // hint: 'Select Gender',
            maxChars: 10,
            required: showAsterix,
            disabled: !personAdd && (disabled || activeFormName !== 'ypd'),
            options: valueTable.gender.filter(f => f.id > 0).map(o => {
              return { value: o.label, label: o.label }
            }),
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.select,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'person.careStatus',
            label: 'Care Status',
            maxChars: 35,
            disabled: !personAdd && (disabled || activeFormName !== 'ypd'),
            // hint: 'Select Care Status',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: valueTable.careStatus.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        [
          {
            type: fields.select,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'person.primaryReason.id',
            label: 'Primary Reason in Care',
            maxChars: 60,
            // hint: 'Select Primary Reason',
            disabled: !personAdd && (disabled || activeFormName !== 'ypd'),
            required: showAsterix,
            options: reasons.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            }),
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.text,
            // style: { ...styles.fieldText },
            floatingLabelStyle: { width: 250 }, // { ...styles.floatingLabel, width: 250 },
            name: 'person.placementNumber',
            label: 'No. of Previous Placements',
            maxChars: 5,
            disabled: !personAdd && (disabled || activeFormName !== 'ypd'),
            // hint: 'Enter Previous Placements Number',
            validate: v => (v ? undefined : 'Field is required')
          }
        ]
        // {
        //   type: fields.spacer,
        //   style: { height: 40 }
        // },
      ]
    },
    {
      id: 2,
      name: 'pad',
      disabled: activeFormName !== 'ypd',
      activeName: 'person',
      historyName: 'personHistory',
      label: 'Parents Details',
      icon: 'supervisor_account',
      fields: [
        [
          {
            type: fields.text,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'person.parents.motherName',
            label: "Mother's Name",
            maxChars: 50,
            // hint: "Enter Mother's Name",
            required: showAsterix,
            disabled: !personAdd && (disabled || activeFormName !== 'ypd'),
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.text,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'person.parents.motherAddress',
            label: "Mother's Address",
            // maxChars: 100,
            // hint: "Enter Mother's Name",
            rows: 1,
            maxRows: 10,
            required: showAsterix,
            disabled: !personAdd && (disabled || activeFormName !== 'ypd'),
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          }
        ],
        [
          {
            type: fields.text,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'person.parents.fatherName',
            label: "Father's Name",
            maxChars: 50,
            // hint: "Enter Father's Name",
            required: showAsterix,
            disabled: !personAdd && (disabled || activeFormName !== 'ypd'),
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.text,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'person.parents.fatherAddress',
            label: "Father's Address",
            rows: 1,
            maxRows: 10,
            // maxChars: 100,
            // hint: "Enter Father's Name",
            required: showAsterix,
            disabled: !personAdd && (disabled || activeFormName !== 'ypd'),
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          }
        ]
        // [
        //   {
        //     type: fields.component,
        //     component: (
        //       <MuiTable
        //         subform
        //         layout={MuiTable.layouts.fieldArray}
        //         title={'motherAddress'}
        //         disabled={disabled}
        //         defaultNew={{
        //           id: _.maxBy(
        //             formValues.person &&
        //               formValues.person.parents &&
        //               formValues.person.parents.motherAddress,
        //             'id'
        //           )
        //             ? _.maxBy(
        //                 formValues.person &&
        //                   formValues.person.parents &&
        //                   formValues.person.parents.motherAddress,
        //                 'id'
        //               ).id + 1
        //             : 1,
        //           phone: ''
        //         }}
        //         // style={{ display: visible.social ? '' : 'none' }}
        //         columns={[
        //           {
        //             name: 'motherAddress',
        //             label: "Mother's Address",
        //             compact: true,
        //             formField: true,
        // hint: "Enter Mother's Address",
        //             rows: 1,
        //             maxRows: 10,
        //             required: showAsterix,
        //             type: fields.text,
        //             normalize: v => {
        //               const val = keepInLength(v, 300)
        //               return val
        //             },
        //             validate: v => (v ? undefined : 'Field is required')
        //           }
        //         ]}
        //         data={
        //           formValues.person &&
        //           formValues.person.parents &&
        //           formValues.person.parents.motherAddress
        //         }
        //       />
        //     )
        //   }
        // ]
      ]
    },
    {
      id: 3,
      name: 'swd',
      disabled: activeFormName !== 'swd',
      activeName: 'social',
      historyName: 'socialHistory',
      label: 'Social Worker Details',
      icon: 'visibility',
      fields: [
        [
          {
            type: fields.select,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'social.workRegion',
            label: 'SW Region', //'Social Work Region',
            maxChars: 15,
            disabled: !add && (disabled || activeFormName !== 'swd'),
            // hint: 'Select Work Region',
            required: showAsterix,
            options: valueTable.workRegion.map(o => {
              return { value: o.id, label: o.label }
            }),
            validate: v =>
              activeFormName !== 'swd' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          },
          {
            type: fields.select,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'social.workArea',
            label: 'SW Area', //'Social Work Area',
            maxChars: 15,
            disabled: !add && (disabled || activeFormName !== 'swd'),
            // hint: 'Select Work Area',
            required: showAsterix,
            options: valueTable.workArea.map(o => {
              return { value: o.id, label: o.label }
            }),
            validate: v =>
              activeFormName !== 'swd' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          },
          {
            type: fields.select,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'social.workTeam',
            label: 'Social Work Team',
            disabled: !add && (disabled || activeFormName !== 'swd'),
            maxChars: 30,
            // hint: 'Select Work Team',
            required: showAsterix,
            options: valueTable.workTeam.map(o => {
              return { value: o.id, label: o.label }
            }),
            validate: v =>
              activeFormName !== 'swd' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          },
          {
            type: fields.text,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'social.workerFax',
            label: 'Social Worker Fax No.(s)',
            maxChars: 30,
            // hint: 'Enter Fax Number',
            required: showAsterix,
            validate: v =>
              v
                ? isFax(v)
                  ? undefined
                  : 'Fax number should have 8 or 9 digit with leading 0'
                : 'Field is required',
            normalize: v => v.toLowerCase()
          }
        ],
        [
          {
            type: fields.text,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'social.workerName',
            label: 'Social Worker Name',
            maxChars: 50,
            disabled: !add && (disabled || activeFormName !== 'swd'),
            // hint: 'Enter Worker Name',
            required: showAsterix,
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v =>
              activeFormName !== 'swd' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          },
          {
            type: fields.text,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'social.workerAddress',
            label: 'Social Worker Address',
            disabled: !add && (disabled || activeFormName !== 'swd'),
            // hint: 'Enter Worker Address',
            rows: 1,
            maxRows: 10,
            required: showAsterix,
            normalize: v => {
              const val = keepInLength(v, 300)
              return val
            },
            validate: v =>
              activeFormName !== 'swd' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          }
        ],
        [
          {
            name: 'social.email',
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            label: 'Social Worker Email Address',
            disabled: !add && (disabled || activeFormName !== 'swd'),
            compact: true,
            formField: true,
            type: fields.text,
            maxChars: 50,
            validate: v =>
              activeFormName !== 'swd' && !add
                ? undefined
                : v
                  ? isEmail(v)
                    ? undefined
                    : 'Enter valid email address'
                  : 'Field is required',
            normalize: v => v.toLowerCase()
          },
          {
            name: 'social.phone',
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            label: 'Social Worker Phone No.',
            disabled: !add && (disabled || activeFormName !== 'swd'),
            maxChars: 50,
            compact: true,
            formField: true,
            type: fields.text,
            validate: v =>
              activeFormName !== 'swd' && !add
                ? undefined
                : v
                  ? isPhone(v)
                    ? undefined
                    : 'Phone number should have 8 or 9 digit with leading 0'
                  : 'Field is required'
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel, width: 300 },
            name: 'social.validFrom',
            label: 'Social Work Details Valid at Date',
            disabled: !add && (disabled || activeFormName !== 'swd'),
            maxChars: 20,
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'swd' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          }
        ]
        // [
        // {
        //   type: fields.component,
        //   component: (
        //     <MuiTable
        //       subform
        //       name='yp'
        //       layout={MuiTable.layouts.fieldArray}
        //       title={'workerEmails'}
        //       // disabled={this.disabled}
        //       // defaultNew={{
        //       //   id: _.maxBy(formValues.workerEmails, 'id') ? _.maxBy(formValues.workerEmails, 'id').id + 1 : 1,
        //       //   email: ''
        //       // }}
        //       columns={
        //         [
        //           {
        //             name: 'email',
        //             label: 'Social Worker Email Address',
        //             compact: true,
        //             formField: true,
        //             type: fields.text,
        //             validate: v =>
        //               v ? isEmail(v) ? undefined : 'Enter valid email address'
        //                 : 'Field is required',
        //             normalize: v => v.toLowerCase()
        //           }
        //         ]}
        //     // data={initVal.workerEmails}
        //     />
        //   )

        // },
        //   {
        //     type: fields.component,
        //     component: (
        //       <MuiTable
        //         subform
        //         layout={MuiTable.layouts.fieldArray}
        //         title={'workerPhones'}
        //         // disabled={this.isDisabled()}
        //         // defaultNew={{
        //         //   id: _.maxBy(formValues.workerPhones, 'id') ? _.maxBy(formValues.workerPhones, 'id').id + 1 : 1,
        //         //   phone: ''
        //         // }}
        //         columns={
        //           [
        //             {
        //               name: 'phone',
        //               label: 'Social Worker Phone No.',
        //               compact: true,
        //               formField: true,
        //               type: fields.text,
        //               validate: v =>
        //                 v ? isPhone(v)
        //                   ? undefined
        //                   : 'Phone number should have 8 or 9 digit with leading 0'
        //                   : 'Field is required'
        //             }
        //           ]}
        //       // data={initVal.workerPhones}
        //       />
        //     )

        //   }
        // ]
      ]
    },
    {
      id: 4,
      name: 'pld',
      disabled: activeFormName !== 'pld',
      activeName: 'placement',
      historyName: 'placementHistory',
      label: 'Placement Details',
      icon: 'home',
      fields: [
        // [
        //   {
        //     type: fields.select,
        //     style: { ...styles.fieldText },
        //     floatingLabelStyle: { ...styles.floatingLabel },
        //     name: 'placement.careStatus',
        //     label: "Young Person's Care Status",
        //     // hint: 'Select Care Status',
        //     required: showAsterix,
        //     validate: v => (v ? undefined : 'Field is required'),
        //     options: valueTable.careStatus.filter(f => f.id > 0).map(o => {
        //       return { value: o.id, label: o.label }
        //     })
        //   },
        //   {
        //     type: fields.select,
        //     style: { ...styles.fieldText },
        //     floatingLabelStyle: { ...styles.floatingLabel },
        //     name: 'placement.primaryReason.id',
        //     label: 'Primary Reason Young Person in Care',
        //     // hint: 'Select Primary Reason',
        //     required: showAsterix,
        //     options: reasons.filter(f => f.id > 0).map(o => {
        //       return { value: o.id, label: o.label }
        //     }),
        //     validate: v => (v ? undefined : 'Field is required')
        //   },
        //   {
        //     type: fields.text,
        //     style: { ...styles.fieldText },
        //     floatingLabelStyle: { ...styles.floatingLabel },
        //     name: 'placement.placementNumber',
        //     label: 'No. of Previous Placements',
        //     // hint: 'Enter Previous Placements Number',
        //     validate: v => (v ? undefined : 'Field is required')
        //   }
        // ],
        // {
        //   type: fields.spacer,
        //   style: { height: 40 }
        // },
        // [
        //   {
        //     type: fields.select,
        //     // style: { ...styles.fieldText },
        //     // floatingLabelStyle: { ...styles.floatingLabel },
        //     name: 'placement.careStatus',
        //     label: "Young Person's Care Status",
        //     disabled: !add && (disabled || activeFormName !== 'pld'),
        //     // hint: 'Select Care Status',
        //     required: showAsterix,
        //     validate: v =>
        //       activeFormName !== 'pld' && !add
        //         ? undefined
        //         : v
        //           ? undefined
        //           : 'Field is required',
        //     options: valueTable.careStatus.filter(f => f.id > 0).map(o => {
        //       return { value: o.id, label: o.label }
        //     })
        //   },
        //   {
        //     type: fields.select,
        //     // style: { ...styles.fieldText },
        //     // floatingLabelStyle: { ...styles.floatingLabel },
        //     name: 'placement.primaryReason.id',
        //     label: 'Primary Reason Young Person in Care',
        //     disabled: !add && (disabled || activeFormName !== 'pld'),
        //     // hint: 'Select Primary Reason',
        //     required: showAsterix,
        //     options: reasons.filter(f => f.id > 0).map(o => {
        //       return { value: o.id, label: o.label }
        //     }),
        //     validate: v =>
        //       activeFormName !== 'pld' && !add
        //         ? undefined
        //         : v
        //           ? undefined
        //           : 'Field is required'
        //   },
        //   {
        //     type: fields.text,
        //     // style: { ...styles.fieldText },
        //     // floatingLabelStyle: { ...styles.floatingLabel },
        //     name: 'placement.placementNumber',
        //     label: 'No. of Previous Placements',
        //     disabled: !add && (disabled || activeFormName !== 'pld'),
        //     // hint: 'Enter Previous Placements Number',
        //     validate: v =>
        //       activeFormName !== 'pld' && !add
        //         ? undefined
        //         : v
        //           ? undefined
        //           : 'Field is required'
        //   }
        // ],
        // {
        //   type: fields.spacer,
        //   style: { height: 40 }
        // },
        [
          {
            type: fields.select,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'placement.placementStatus.id',
            label: 'Placement Status',
            maxChars: 30,
            disabled: !add && (disabled || activeFormName !== 'pld'),
            // hint: 'Select Placement Status',
            required: showAsterix,

            options: valueTable.placementStatus.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            }),
            validate: v =>
              activeFormName !== 'pld' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel, width: 300 },
            name: 'placement.placementStatus.validFrom',
            label: 'Status Valid at Date', //'Placement Status Valid at Date',
            maxChars: 20,
            disabled: !add && (disabled || activeFormName !== 'pld'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'pld' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          }
        ],
        [
          {
            type: fields.select,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'placement.placementPurpose.id',
            label: 'Placement Purpose',
            maxChars: 90,
            disabled: !add && (disabled || activeFormName !== 'pld'),
            // hint: 'Select Placement Purpose',
            required: showAsterix,
            options: valueTable.placementPurpose.map(o => {
              return { value: o.id, label: o.label }
            }),
            validate: v =>
              activeFormName !== 'pld' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel, width: 300 },
            name: 'placement.placementPurpose.validFrom',
            label: 'Purpose Valid at Date', //'Placement Purpose Valid at Date',
            disabled: !add && (disabled || activeFormName !== 'pld'),
            required: showAsterix,
            maxChars: 20,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'pld' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          }
        ],
        {
          type: fields.spacer,
          style: { height: 40 }
        },
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel, width: 300 },
            name: 'placement.admission.admissionDate',
            label: 'Admission Date', //'Date of Admission',
            maxChars: 20,
            disabled: !add && (disabled || activeFormName !== 'pld'),
            minDate:
              formValues && formValues.person && formValues.person.dob
                ? new Date(formValues.person.dob)
                : undefined,
            maxDate:
              formValues &&
              formValues.placement &&
              formValues.placement.discharge &&
              formValues.placement.discharge.dischargeDate
                ? new Date(formValues.placement.discharge.dischargeDate)
                : undefined,
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { ...styles.fieldText, width: 150 },
            onChange: (e, v) => {
              change(
                formName,
                'placement.admission.admissionAge',
                calculatePeriod(
                  v,
                  formValues && formValues.person && formValues.person.dob
                )
              )
              change(
                formName,
                'placement.discharge.placementDuration',
                calculatePeriod(
                  v,
                  formValues &&
                    formValues.placement &&
                    formValues.placement.discharge &&
                    formValues.placement.discharge.dischargeDate
                )
              )
              // change(
              //   formName,
              //   'discharge.placementDuration',
              //   calculatePeriod(v, dischargeDate)
              // )
            },
            validate: v =>
              activeFormName !== 'pld' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          },
          {
            type: fields.text,
            style: { ...styles.fieldText, marginTop: '0px !important' },
            // floatingLabelStyle: { ...styles.floatingLabel, width: 300 },
            name: 'placement.admission.admissionAge',
            label: 'Age on Admission',
            maxChars: 20,
            value: calculatePeriod(
              formValues && formValues.person && formValues.person.dob,
              formValues &&
                formValues.placement &&
                formValues.placement.admission &&
                formValues.placement.admission.admissionDate
            ),

            // component: v => (
            //   <MuiTextfield
            //     style={{
            //       ...styles.fieldText,
            //       height: '1.851rem',
            //       marginTop: -10
            //     }}
            //     disabled={true}
            //     // input={{
            //     //   floatingLabelStyle: { ...styles.floatingLabel, width: 300 }
            //     // }}
            //     value={calculatePeriod(
            //       formValues && formValues.person && formValues.person.dob,
            //       formValues &&
            //         formValues.placement &&
            //         formValues.placement.admission &&
            //         formValues.placement.admission.admissionDate
            //     )}
            //     label={'Age on Admission'}
            //   />
            // ),
            disabled: true
          },
          {
            type: fields.select,
            //style: { ...styles.fieldText },
            //floatingLabelStyle: { ...styles.floatingLabel },
            name: 'placement.admission.placementTypeFrom',
            label: 'Admitted from Placement Type',
            maxChars: 40,
            disabled: !add && (disabled || activeFormName !== 'pld'),
            // hint: 'Select Placement Type',
            required: showAsterix,
            options: valueTable.placementType.map(o => {
              return { value: o.id, label: o.label }
            }),
            validate: v =>
              activeFormName !== 'pld' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          },
          {
            type: fields.select,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'placement.admission.serviceTypeFrom',
            label: 'Admitted from Service Type',
            disabled: !add && (disabled || activeFormName !== 'pld'),
            maxChars: 40,
            // hint: 'Select Service Type',
            required: showAsterix,
            options: valueTable.serviceType.map(o => {
              return { value: o.id, label: o.label }
            }),
            validate: v =>
              activeFormName !== 'pld' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          }
        ],
        [
          {
            type: fields.select,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            name: 'placement.admission.centreNameTo.id',
            label: 'Admitted to Centre Name',
            disabled: !add && (disabled || activeFormName !== 'pld'),
            maxChars: 50,
            // hint: 'Select Centre Name',
            required: showAsterix,
            options: centres.map(o => {
              return { value: o.id, label: o.name }
            }),
            validate: v =>
              activeFormName !== 'pld' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          }
        ],
        // {
        //   type: fields.text,
        //   name: 'admission.centreAddress',
        //   label: 'Centre Address',
        // (hint: 'Enter Centre Address'),
        //   required: showAsterix,
        //   validate: v => (v ? undefined : 'Field is required')
        // }
        // ],
        {
          type: fields.spacer,
          style: { height: 40 },
          hidden:
            _.get(formValues, 'placement.placementStatus.id') &&
            !_.includes(
              [20, 30],
              _.get(formValues, 'placement.placementStatus.id')
            )
        },
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel, width: 300 },
            name: 'placement.discharge.dischargeDate',
            label: 'Date of Discharge',
            maxChars: 20,
            disabled: !add && (disabled || activeFormName !== 'pld'),
            required: showAsterix,
            hidden:
              _.get(formValues, 'placement.placementStatus.id') &&
              !_.includes(
                [20, 30],
                _.get(formValues, 'placement.placementStatus.id')
              ),
            minDate:
              formValues &&
              formValues.placement &&
              formValues.placement.admission &&
              formValues.placement.admission.admissionDate
                ? new Date(formValues.placement.admission.admissionDate)
                : undefined,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: 150, ...styles.fieldText },
            onChange: (e, v) => {
              change(
                formName,
                'placement.discharge.dischargeAge',
                calculatePeriod(
                  v,
                  formValues && formValues.person && formValues.person.dob
                )
              )
              change(
                formName,
                'placement.discharge.placementDuration',
                calculatePeriod(
                  v,
                  formValues &&
                    formValues.placement &&
                    formValues.placement.admission &&
                    formValues.placement.admission.admissionDate
                )
              )
            },
            validate: v =>
              activeFormName !== 'pld' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          },
          {
            type: fields.text,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            maxChars: 20,
            hidden:
              _.get(formValues, 'placement.placementStatus.id') &&
              !_.includes(
                [20, 30],
                _.get(formValues, 'placement.placementStatus.id')
              ),
            name: 'placement.discharge.dischargeAge',
            label: 'Age at Discharge',
            value: calculatePeriod(
              formValues && formValues.person && formValues.person.dob,
              formValues &&
                formValues.placement &&
                formValues.placement.discharge &&
                formValues.placement.discharge.dischargeDate
            ),
            // component: v => (
            //   <MuiTextfield
            //     style={styles.fieldText}
            //     disabled={true}
            //     // input={{
            //     //   floatingLabelStyle: { ...styles.floatingLabel }
            //     // }}
            //     value={calculatePeriod(
            //       formValues && formValues.person && formValues.person.dob,
            //       formValues &&
            //         formValues.placement &&
            //         formValues.placement.discharge &&
            //         formValues.placement.discharge.dischargeDate
            //     )}
            //     label={'Age at Discharge'}
            //   />
            // ),
            disabled: true
          },
          {
            type: fields.select,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            maxChars: 40,
            hidden:
              _.get(formValues, 'placement.placementStatus.id') &&
              !_.includes(
                [20, 30],
                _.get(formValues, 'placement.placementStatus.id')
              ),
            name: 'placement.discharge.placementTypeTo',
            label: 'Discharged To Placement Type',
            disabled: !add && (disabled || activeFormName !== 'pld'),
            // hint: 'Select Placement To Type',
            required: showAsterix,
            options: valueTable.placementType.map(o => {
              return { value: o.id, label: o.label }
            }),
            validate: v =>
              activeFormName !== 'pld' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          },
          {
            type: fields.select,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            maxChars: 40,
            hidden:
              _.get(formValues, 'placement.placementStatus.id') &&
              !_.includes(
                [20, 30],
                _.get(formValues, 'placement.placementStatus.id')
              ),
            name: 'placement.discharge.serviceTypeTo',
            label: 'Discharged to Service Type',
            disabled: !add && (disabled || activeFormName !== 'pld'),
            // hint: 'Select Service Type',
            required: showAsterix,
            options: valueTable.serviceType.map(o => {
              return { value: o.id, label: o.label }
            }),
            validate: v =>
              activeFormName !== 'pld' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          },
          {
            type: fields.text,
            // style: { ...styles.fieldText },
            floatingLabelStyle: {
              width: 300
            },
            maxChars: 20,
            hidden:
              _.get(formValues, 'placement.placementStatus.id') &&
              !_.includes(
                [20, 30],
                _.get(formValues, 'placement.placementStatus.id')
              ),
            name: 'placement.discharge.placementDuration',
            label: 'Placement Duration',
            value: calculatePeriod(
              formValues &&
                formValues.placement &&
                formValues.placement.admission &&
                formValues.placement.admission.admissionDate,
              formValues &&
                formValues.placement &&
                formValues.placement.discharge &&
                formValues.placement.discharge.dischargeDate
            ),

            // component: v => (
            //   <MuiTextfield
            //     style={styles.fieldText}
            //     disabled={true}
            //     // input={{
            //     //   floatingLabelStyle: { width: 300 }
            //     // }}
            //     value={calculatePeriod(
            //       formValues &&
            //         formValues.placement &&
            //         formValues.placement.admission &&
            //         formValues.placement.admission.admissionDate,
            //       formValues &&
            //         formValues.placement &&
            //         formValues.placement.discharge &&
            //         formValues.placement.discharge.dischargeDate
            //     )}
            //     label={'Placement Duration'}
            //   />
            // ),
            disabled: true
          }
        ],
        [
          {
            type: fields.text,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            maxChars: 50,
            hidden:
              _.get(formValues, 'placement.placementStatus.id') &&
              !_.includes(
                [20, 30],
                _.get(formValues, 'placement.placementStatus.id')
              ),
            name: 'placement.discharge.organizationTo',
            label: 'Discharge to Organisation',
            disabled: !add && (disabled || activeFormName !== 'pld'),
            // hint: 'Select Organization',
            required: showAsterix,
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v =>
              activeFormName !== 'pld' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          },
          {
            type: fields.select,
            // style: { ...styles.fieldText },
            // floatingLabelStyle: { ...styles.floatingLabel },
            maxChars: 90,
            hidden:
              _.get(formValues, 'placement.placementStatus.id') &&
              !_.includes(
                [20, 30],
                _.get(formValues, 'placement.placementStatus.id')
              ),
            name: 'placement.discharge.type',
            label: 'Discharge Type',
            disabled: !add && (disabled || activeFormName !== 'pld'),
            // hint: 'Select Type',
            required: showAsterix,
            options: valueTable.dischargeType.map(o => {
              return { value: o.id, label: o.label }
            }),
            validate: v =>
              activeFormName !== 'pld' && !add
                ? undefined
                : v
                  ? undefined
                  : 'Field is required'
          }
        ]
      ]
    },
    {
      id: 5,
      name: 'pln',
      disabled: activeFormName !== 'pln',
      activeName: 'notes',
      historyName: 'notesHistory',
      label: 'Placement Notes',
      icon: 'note',
      fields: [
        {
          type: fields.text,
          // style: { ...styles.fieldText },
          // floatingLabelStyle: { ...styles.floatingLabel },
          rows: 4,
          maxRows: 10,
          required: showAsterix,
          name: 'notes.placement',
          label: 'Placement Notes',
          disabled: !add && (disabled || activeFormName !== 'pln'),
          // hint: 'Enter Placement Notes',
          normalize: v => {
            const val = keepInLength(v, 500)
            return val
          }
          // validate: v =>
          //   activeFormName !== 'pln'
          //     ? undefined
          //     : v ? undefined : 'Field is required'
        }
      ]
    }
  ]

  return forms
}

export const activeSection = ['person', 'social', 'placement', 'notes']

export const errors = [1] //, 2, 3, 4]

export const defaultNew = {
  person: {
    dob: null, //dobDate,
    age: null, //calculateAge(dobDate)
    firstName: '',
    lastName: '',
    fullName: '',
    gender: '',
    nationality: '',
    historyId: 'new',
    id: 'new',
    personId: 'new',
    initials: '',
    parents: {
      motherName: '',
      fatherName: ''
    },
    audit: {
      active: true,
      createdDate: new Date(),
      createdBy: getLoginFromMail(getUserId())
    }
  },
  social: {
    historyId: 'new',
    audit: {
      active: true,
      createdDate: new Date(),
      createdBy: getLoginFromMail(getUserId())
    }
  },
  socialHistory: [],
  personHistory: [],
  placementHistory: [],
  notesHistory: [],
  admission: {
    historyId: 'new',
    audit: {
      active: true,
      createdDate: new Date(),
      createdBy: getLoginFromMail(getUserId())
    }
  },
  discharge: {
    historyId: 'new',
    audit: {
      active: true,
      createdDate: new Date(),
      createdBy: getLoginFromMail(getUserId())
    }
  },
  placement: {
    historyId: 'new',
    audit: {
      active: true,
      createdDate: new Date(),
      createdBy: getLoginFromMail(getUserId())
    }
  },
  notes: {
    historyId: 'new',
    audit: {
      active: true,
      createdDate: new Date(),
      createdBy: getLoginFromMail(getUserId())
    }
  }
}



// WEBPACK FOOTER //
// ./src/register/configs/register.js